import { Loader2 } from 'lucide-react'
import { cn } from '../lib/cn.js'

export function Spinner({ className, label = 'جارٍ التحميل…' }: { className?: string; label?: string }) {
  return (
    <span role="status" aria-label={label}>
      <Loader2 className={cn('size-5 animate-spin text-fg-subtle', className)} aria-hidden />
      <span className="sr-only">{label}</span>
    </span>
  )
}

export function FullPageSpinner({ label = 'جارٍ التحميل…' }: { label?: string }) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-3 bg-bg">
      <Spinner className="size-7 text-primary" label={label} />
      <p className="text-sm text-fg-muted">{label}</p>
    </div>
  )
}
